import { Locale } from "@/Common/Models/Localization/Locale";
import { URL_CONFIG } from "../Configuration/url";

export class UrlService {
    public static getTrackApplicationStatusUrl(language: Locale): string {
        switch (language) {
            case Locale.fr:
                return URL_CONFIG.STATUS_TRACKING.fr;
            case Locale.es:
                return URL_CONFIG.STATUS_TRACKING.es;
            default:
                return URL_CONFIG.STATUS_TRACKING.en;
        }
    }

    public static getRemoteAccessUrl(): string {
        const isWindows = window.navigator.userAgent.toLowerCase().includes("win");
        return isWindows
            ? URL_CONFIG.REMOTE_ACCESS.windows
            : URL_CONFIG.REMOTE_ACCESS.mac;
    }

    public static getHelpUrl(language: Locale): string {
        return `${URL_CONFIG.HELP_SITE}?language=${language}`;
    }

    public static getCampaignUrl(campaignId: number, language: Locale): string {
        return `${URL_CONFIG.CAMPAIGN_CONTENT}/${campaignId}/${language}.html`;
    }
}
